import startCloudinaryResponsive from '../utils/rbata.cloudinary';
import parallax from '../utils/rbata.parallax';

const productTileSlider = {
    $tilesWrapper:    undefined,
    $pageMain:        undefined,
    slider:           [],
    observer:         undefined,
    slideLoadedClass: 'tile__slide--loaded',
    options:          {
        rootMargin: '50px',
        threshold:  [0.05]
    },

    initSlider(target) {
        const $this          = $(target);
        const amountOfSlides = $this.data('slides');

        if (amountOfSlides > 0) {
            const currentSliderWrapper = $this.find('.tile-slider');
            if (!productTileSlider.slider.hasOwnProperty($this[0].id) && !currentSliderWrapper.hasClass(productTileSlider.slideLoadedClass)) {
                currentSliderWrapper.parent().addClass('tile-slider--hover');
                productTileSlider.bindSlider(currentSliderWrapper);
            }
        }
    },

    bindSlider(container) {
        const controls = container.parent().find('.tile__controls');
        productTileSlider.slider.push(tns({
            container:         container[0],
            mode:              'gallery',
            items:             1,
            slideBy:           1,
            autoplay:          false,
            autoWidth:         false,
            autoHeight:        false,
            arrowKeys:         true,
            speed:             alphatauri.config.sliderProductTileSlideAnimation ?? 300,
            controlsContainer: controls[0],
            controls:          true,
            nav:               true,
            touch:             true,
            mouseDrag:         true,
            loop:              true,
            nested:            'inner',
            onInit:            function () {
                parallax.reloadParallaxPool();
                parallax.onScrollAndLoad();
                startCloudinaryResponsive();
                container.addClass(productTileSlider.slideLoadedClass)
            }
        }))
    },

    observerActions(entries, observer) {
        $.each(entries, (_, entry) => {
            if (entry.intersectionRatio > productTileSlider.options.threshold[0]) {
                if (entry.target) {
                    productTileSlider.initSlider(entry.target)
                    observer.unobserve(entry.target);
                }
            }
        })
    },

    bindEvents() {
        this.$tilesWrapper.on('click', '.tile__arrow, .tns-nav', function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
        });
    },

    bindObserver() {
        if (!this.observer) {
            this.observer = new IntersectionObserver(this.observerActions, this.options);
        }

        if (this.$tilesWrapper.length) {
            this.$tilesWrapper.each((_, item) => {
                this.observer.observe(item);
            })
        }
    },

    cacheSelectors() {
        this.$pageMain     = $('.page-main');
        this.$tilesWrapper = $('.js-product-tile');
    },

    init() {
        this.cacheSelectors();
        this.bindObserver();
        this.bindEvents();
    },

    reInitOne(item) {
        productTileSlider.initSlider(item);
    },

    reInit() {
        for (const tns of productTileSlider.slider) {
            if (tns && typeof (tns.destroy) === typeof (Function)) {
                tns.destroy();
            }
        }
        productTileSlider.slider = [];
        if (productTileSlider.observer) {
            productTileSlider.observer.disconnect();
        }
        productTileSlider.init();
    }
}

$(() => {
    productTileSlider.init();
});

export default productTileSlider;